/* eslint-disable function-paren-newline */
import React, { FC } from 'react';
import { ChevronArrowRightIcon } from 'assets/icons';
import { EstimateTimelineEvent } from '../estimates.model';
import { VoidFn } from 'types/baseTypes';
import EstimateTimelineSection from './EstimateTimelineSection';

interface EstimateTimelineProps {
  estimateTimeline: EstimateTimelineEvent[];
  limit?: number;
  onEditNoteClick: (event: EstimateTimelineEvent) => void;
  onDeleteNoteClick: (event: EstimateTimelineEvent) => void;
  hasImageViewer?: boolean;
  showPreview?: (index: number, event: EstimateTimelineEvent) => void;
  timelineId: string;
  currentActionsPopoverId: number;
  setCurrentActionsPopoverId: (noteId: number) => void;
  onViewHistoryClick: VoidFn;
  isEditAllowed: boolean;
}

const EstimateTimeline: FC<EstimateTimelineProps> = ({
  estimateTimeline,
  limit,
  onEditNoteClick,
  onDeleteNoteClick,
  hasImageViewer,
  showPreview,
  timelineId,
  currentActionsPopoverId,
  setCurrentActionsPopoverId,
  onViewHistoryClick,
  isEditAllowed
}) => {
  return (
    <div className="flex flex-col">
      <h2 className="mb-2 text-sbase font-bold text-primaryText">History</h2>
      <div className="rounded-md border border-borderGray">
        <EstimateTimelineSection
          estimateTimeline={estimateTimeline}
          limit={limit}
          onEditNoteClick={onEditNoteClick}
          onDeleteNoteClick={onDeleteNoteClick}
          hasImageViewer={hasImageViewer}
          showPreview={showPreview}
          timelineId={timelineId}
          currentActionsPopoverId={currentActionsPopoverId}
          setCurrentActionsPopoverId={setCurrentActionsPopoverId}
          isEditAllowed={isEditAllowed}
        />
        <div className="flex items-center justify-between border-t border-borderGray p-2">
          <button className="text-sbase font-semibold text-primaryBtn" onClick={onViewHistoryClick}>
            <span>Show more</span>
          </button>
          <ChevronArrowRightIcon className="h-4 w-4" />
        </div>
      </div>
    </div>
  );
};

export default EstimateTimeline;
